import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { screenReducer } from './screen-store.reducer';

@NgModule({
  imports: [StoreModule.forFeature('screen', screenReducer)],
})
export class ScreenStoreModule {}
